<template>
  <div class="fts-client fts-studio fts-color--default">
    <vue-headful
      :title="`${vector.name || ''} ${workspace.name || ''} | Inistate Studio`"
    />
    <!-- sidenav -->
    <div
      class="client-sidenav"
      @mouseover="mouseoverSidenav"
      @mouseleave="mouseleaveSidenav"
    >
      <div class="client-sidenav-header">
        <div class="client-sidenav-wrapper">
          <img :src="sidenavLogo" class="client-sidenav-logo" />
        </div>
      </div>
      <div class="client-sidenav-body fts-scrollbar fts-scrollbar-overlay">
        <fts-tippy
          triggerClass="sidenav-menu-outer"
          :content="workspace.name"
          :options="{ arrow: false, placement: 'left' }"
          class="sidenav-menu"
          v-for="workspace in preWorkspaces"
          :key="workspace.id"
        >
          <div
            slot="trigger"
            class="sidenav-menu-wrapper"
            :class="{ active: workspaceId == workspace.id }"
            @click="selectWorkspace(workspace)"
          >
            <div class="sidenav-workspace">{{ workspace.shortName }}</div>
          </div>
        </fts-tippy>
        <!-- dashboard -->
        <fts-tippy
          triggerClass="sidenav-menu-outer"
          content="My Dashboard"
          :options="{ arrow: false, placement: 'left' }"
          class="sidenav-menu"
        >
          <div
            slot="trigger"
            class="sidenav-menu-wrapper"
            @click="redirectDashboard"
          >
            <font-awesome-icon
              :icon="['fas', 'th-large']"
              fixed-width
              size="lg"
              class="sidenav-icon"
            />
          </div>
        </fts-tippy>
        <!-- users -->
        <fts-tippy
          triggerClass="sidenav-menu-outer"
          content="Users"
          :options="{ arrow: false, placement: 'left' }"
          class="sidenav-menu"
        >
          <router-link
            slot="trigger"
            :to="{ name: 'users' }"
            class="sidenav-menu-wrapper"
            data-v-step="studio-tour-manage-user"
          >
            <font-awesome-icon
              :icon="['fas', 'user-friends']"
              fixed-width
              size="lg"
              class="sidenav-icon"
            />
          </router-link>
        </fts-tippy>
        <!-- invitation -->
        <fts-tippy
          triggerClass="sidenav-menu-outer"
          content="Invite"
          :options="{ arrow: false, placement: 'left' }"
          class="sidenav-menu"
        >
          <div
            slot="trigger"
            class="sidenav-menu-wrapper"
            @click="openInvitation"
            data-v-step="studio-tour-invite-user"
          >
            <font-awesome-icon
              :icon="['fas', 'user-plus']"
              fixed-width
              size="lg"
              class="sidenav-icon"
            />
          </div>
        </fts-tippy>
      </div>
      <!-- sidenav footer -->
      <div class="client-sidenav-footer">
        <!-- tour -->
        <fts-tippy
          triggerClass="sidenav-menu-outer"
          content="Studio Tour"
          :options="{ arrow: false, placement: 'left' }"
          class="sidenav-menu"
        >
          <div
            slot="trigger"
            class="sidenav-menu-wrapper"
            @click="startTour()"
            data-v-step="studio-tour-help"
          >
            <font-awesome-icon
              :icon="['far', 'question-circle']"
              fixed-width
              size="lg"
              class="sidenav-icon"
            />
          </div>
        </fts-tippy>
        <!-- client -->
        <fts-tippy
          trigger-class="sidenav-menu-outer"
          content="Run app"
          :options="{ arrow: false, placement: 'left' }"
          class="sidenav-menu apex"
        >
          <div
            slot="trigger"
            class="sidenav-menu-wrapper"
            @click="runApp()"
          >
            <font-awesome-icon
              :icon="['fas', 'play']"
              fixed-width
              size="lg"
              class="sidenav-icon"
            />
          </div>
        </fts-tippy>
        <!-- profile -->
        <fts-profile
          :profile="profile"
          :profile-photo-size="30"
          :profile-name="false"
          profile-photo-class="user-profile-avatar"
          class="client-user-profile"
          @click.native="openUserProfileModal"
        />
      </div>
    </div>
    <!-- drawer -->
    <div
      class="client-drawer"
      :class="[{ collapsed: !drawer }, { close: !drawer && !drawerToggle }]"
      @mouseover="mouseoverDrawer"
      @mouseleave="mouseleaveDrawer"
    >
      <div class="client-drawer-header">
        <fts-dropdown-select
          class="client-dropdown"
          append-toggle-class="client-dropdown-toggle"
          content-class="client-content client-dropdown-menu"
          :offset="[0, 6]"
          :before-open="beforeShowWorkspaceOptions"
          @show="showWorkspaceOptions"
          @selected="selectWorkspace"
          data-v-step="studio-tour-workspace-settings"
        >
          <!-- toggle -->
          <template #toggle>
            <div class="client-dropdown-toggle__label">
              {{workspace.name || "Workspace"}}
            </div>
            <font-awesome-icon
              :icon="['fas', 'caret-down']"
              class="client-dropdown-toggle__caret"
            />
          </template>
          <!-- menu -->
          <template #menu="{ select, defaultOptionClass }">
            <div class="client-dropdown-item">
              <div :class="defaultOptionClass" class="client-dropdown-label" @click="select();openWorkspaceModal();">
                <font-awesome-icon
                  :icon="['fas', 'cog']"
                  fixed-width
                  class="client-dropdown-label__icon"
                />
                Manage workspace
              </div>
            </div>

            <div class="client-dropdown-item">
              <div class="client-dropdown-search">
                <div class="fts-form-control-filter">
                  <input
                    type="text"
                    class="fts-form-control"
                    v-model="workspaceSearch"
                    placeholder="Search workspace"
                    ref="workspaceSearch"
                  />
                  <div class="search-icon">
                    <font-awesome-icon :icon="['fas', 'search']" fixed-width />
                  </div>
                </div>
              </div>
              <template v-if="workspaceOptionList && workspaceOptionList.length">
                <div
                  v-for="workspace in workspaceOptionList"
                  :key="workspace.id"
                  :class="defaultOptionClass"
                  @click="select(workspace)"
                >
                  {{ workspace.name }}
                </div>
              </template>
              <div class="client-dropdown-no-found" v-else>
                <div class="client-dropdown-no-found__icon">
                  <font-awesome-icon :icon="['fas', 'search']" />
                </div>
                <div class="client-dropdown-no-found__label">
                  No matching results
                </div>
              </div>
            </div>

            <div class="client-dropdown-item" v-if="beta">
              <div :class="defaultOptionClass" class="client-dropdown-label" @click="select();openWorkspaceCreateModal();" >
                <font-awesome-icon
                  :icon="['fas', 'plus']"
                  fixed-width
                  class="client-dropdown-label__icon"
                />
                Create a new workspace
              </div> 
            </div>
          </template>
        </fts-dropdown-select>
        <!-- drawer toggle -->
        <fts-tippy
          trigger-class="client-drawer-toggle"
          :options="{ arrow: false }"
          v-if="drawerToggleButton"
        >
          <template #trigger>
            <font-awesome-icon
              :icon="['fas', 'angle-double-left']"
              fixed-width
              @click="toggleDrawer"
              v-if="drawer"
            />
            <font-awesome-icon
              :icon="['fas', 'thumbtack']"
              fixed-width
              @click="toggleDrawer"
              v-else
            />
          </template>
          <div slot="content">{{ drawer ? "close sidebar" : "lock sidebar open" }}</div>
        </fts-tippy>
      </div>
      <div class="client-drawer-body fts-scrollbar fts-scrollbar-overlay">
        <!-- module -->
        <fts-module-designer
          :list="workspace.menus"
          v-model="workspace.menus"
          @listSelected="selectList($event)"
          @moduleSelected="selectModule($event)"
          @deleteModule="deleteModule"
        />
      </div>
      <div
        class="client-drawer-action"
        @click="openModuleCreateModal"
        data-v-step="studio-tour-create-module"
      >
        <font-awesome-icon
          :icon="['fas', 'plus']"
          class="client-drawer-action-icon"
        />
        <div>
          Create New Module
        </div>
      </div>
      <div class="client-drawer-footer">
        <fts-profile
          :profile="profile"
          :profile-photo="false"
          profile-name-class="user-profile-info"
          class="client-user-profile"
          @click.native="openUserProfileModal"
        >
          <template #profileName="{ userProfileName, userProfileUsername }">
            <div class="user-profile-wrapper">
              <div class="user-profile-name">{{ userProfileName }}</div>
              <div class="user-profile-role">{{ userRoles }}</div>
            </div>
            <div
              class="user-profile-username client-drawer-username"
              v-if="userProfileUsername"
            >{{ userProfileUsername }}</div>
          </template>
        </fts-profile>
      </div>
    </div>
    <!-- content -->
    <div
      class="client-content studio-content"
      :class="[
        {'studio-content--scrolled': scroll},
        studioContentClass
      ]"
      @scroll="onScroll"
      ref="studioContent"
      v-if="loaded"
    >
      <div class="content-header">
        <div class="content-nav">
          <!-- nav-l -->
          <div class="content-nav-l">
            <div class="module-wrapper" v-if="vectorId">
              <fts-moji :size="20" :emoji="vector.emoji" class="module-emoji" v-if="vector.emoji" />
              <div class="module-name">{{ vector.name }}</div>
              <div class="module-tag" v-if="vector.isUserCollection">
                <font-awesome-icon :icon="['fas', 'user']" fixed-width />
              </div>
            </div>
          </div>
          <!-- nav-c -->
          <div class="content-nav-c">
            <div class="content-nav-wrapper">
              <font-awesome-icon :icon="['fas', 'wand-magic-sparkles']" fixed-width class="content-nav-icon" />
              <div class="content-nav-title">Studio</div>
              <!-- workflow -->
              <fts-tippy content="Open flow diagram" class="content-nav-action" v-if="vectorId">
                <fts-btn slot="trigger" icon text @click="workflow">
                  <font-awesome-icon :icon="['fas', 'project-diagram']" fixed-width />
                </fts-btn>
              </fts-tippy>
            </div>
          </div>
          <!-- nav-r -->
          <div class="content-nav-r">
            <div class="content-nav-actions">
              <template v-if="vectorId && !isDashboard && !Boolean(moduleCreateMode)">
                <!-- run client -->
                <fts-btn
                  sm
                  text
                  color="secondary"
                  :disabled="saving"
                  data-v-step="studio-tour-run"
                  @click.native.prevent="runApp({target: '_blank'})"
                >
                  <font-awesome-icon :icon="['fas', 'play']" />Run
                </fts-btn>
                <!-- save -->
                <fts-btn
                  sm
                  text
                  color="primary"
                  :loading="saving"
                  @click="save"
                >
                  <font-awesome-icon :icon="['fas', 'check']" />Save
                </fts-btn>
              </template>
              <!-- create:cancel -->
              <fts-btn
                sm
                text
                @click="cancelModuleCreate"
                v-if="moduleCreateMode === 'template'"
              >
                Cancel
              </fts-btn>
            </div>
          </div>
        </div>
      </div>
      <!-- dashboard -->
      <template v-if="isDashboard">
        <fts-dashboard v-if="beta" />
      </template>
      <!-- console -->
      <fts-console
        ref="console"
        :canvas-props="canvas"
        :vector-id="vectorId"
        :vector-props="vector"
        :validator="$v"
        @scrollTo="studioContentScrollTo"
        @update="save()"
        @module:created="moduleCreated"
        @module:selected="selectModule($event)"
        @cancel="cancelModuleCreate"
        @deleteModule="deleteModule"
        v-if="vectorId || moduleCreateMode === 'create'"
      />
      <!-- module packages -->
      <fts-module-packages
        @package:installed="openModuleOnboardModal"
        v-else-if="moduleCreateMode === 'template'"
      />   
    </div>
    <!-- user profile -->
    <fts-user-profile ref="ftsUserProfile" />
    <!-- invitation -->
    <fts-invitation ref="ftsInvitation" />
    <!-- workflow -->
    <fts-workflow ref="ftsWorkflow" />
    <!-- console validator -->
    <fts-console-validator />
    <!-- confirmation -->
    <v-dialog />
    <!-- module create modal -->
    <fts-module-create-modal ref="ftsModuleCreateModal" />
    <!-- module import design modal -->
    <fts-module-import-design-modal ref="ftsModuleImportDesignModal" />
    <!-- module onboard -->
    <fts-module-onboard-modal ref="ftsModuleOnboard" />
    <!-- module delete modal -->
    <fts-module-delete-modal ref="ftsModuleDeleteModal" />
    <!-- workspace modal -->
    <fts-workspace-modal ref="ftsWorkspaceModal" />
    <!-- workspace create modal -->
    <fts-workspace-create-modal ref="ftsWorkspaceCreateModal" />
    <!-- tour modal -->
    <fts-tour-modal ref="ftsTourModal" />
    <!--tour-->
    <v-tour name="myTour" :steps="tourSteps" :callbacks="tourCallbacks">
      <template slot-scope="tour">
        <transition name="fade">
          <v-step
            v-if="tour.steps[tour.currentStep]"
            :key="tour.currentStep"
            :step="tour.steps[tour.currentStep]"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :skip="tour.skip"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
          >
            <div
              class="v-step__buttons"
              slot="actions"
              v-if="tour.isLast && !workspaceModules.length"
            >
              <button class="v-step__button v-step__button-skip" @click="tour.skip">Skip tour</button>
              <button
                class="v-step__button v-step__button-previous"
                @click="tour.previousStep"
              >Previous</button>
              <button class="v-step__button v-step__button-stop" @click="tour.finish">Next</button>
            </div>
          </v-step>
        </transition>
      </template>
    </v-tour>
  </div>
</template>

<script>
import Vue from "vue";
import vueHeadful from "vue-headful";

import VueCookies from "vue-cookies";
Vue.use(VueCookies);

import VueRouter from "vue-router";
Vue.use(VueRouter);

import Vuex from "vuex";
Vue.use(Vuex);

import Vuelidate from "vuelidate";
Vue.use(Vuelidate);

import webAppConfig from "./components/commons/webApp.config";
import commons from "./components/commons/commons";
import validator from "./components/commons/designValidator";
import tours from "./components/commons/tours";
import { store } from "./components/store/canvasDesignStore";
import { authorizationStore } from "./components/store/authorizationStore";

import FTSDashboard from "./components/design/dashboard/FTSDashboard";
import FTSConsole from "./components/design/FTSConsole";
import FTSDropdownSelect from "./components/elements/FTSDropdownSelect";
import FTSModuleDesigner from "./components/design/FTSModuleDesigner";
import FTSMoji from "./components/elements/FTSMoji";
import FTSBtn from "./components/elements/FTSBtn";
import FTSModal from "./components/elements/FTSModal";
import FTSEmoji from "./components/elements/FTSEmoji";
import FTSToggleSwitch from "./components/elements/FTSToggleSwitch";
import FTSConsoleValidator from "./components/design/FTSConsoleValidator";
import FTSUserProfile from "./components/elements/FTSUserProfile";
import FTSProfile from "./components/elements/FTSProfile";
import FTSTippy from "./components/elements/FTSTippy";
import FTSInvitation from "./components/client/FTSInvitation";
import FTSWorkflow from "./components/elements/FTSWorkflow";
import FTSModuleCreateModal from "./components/design/FTSModuleCreateModal";
import FTSModuleImportDesignModal from "./components/design/FTSModuleImportDesignModal";
import FTSModuleOnboardModal from "./components/design/FTSModuleOnboardModal";
import FTSModuleDeleteModal from "./components/design/FTSModuleDeleteModal";
import FTSModulePackages from "./components/design/FTSModulePackages";     
import FTSWorkspaceModal from "./components/design/FTSWorkspaceModal";
import FTSWorkspaceCreateModal from "./components/design/FTSWorkspaceCreateModal";
import FTSTourModal from "./components/elements/tours/FTSTourModal";                                  

import changesets from "diff-json";
import moduleGuard from "./components/commons/moduleGuard";
import VueTour from "vue-tour";
require("vue-tour/dist/vue-tour.css");
Vue.use(VueTour);

import signalr from "./components/store/signalr";

export default {
  name: "app",
  components: {
    "fts-dashboard": FTSDashboard,
    "fts-console": FTSConsole,
    "fts-dropdown-select": FTSDropdownSelect,
    "fts-module-designer": FTSModuleDesigner,
    "fts-moji": FTSMoji,
    "fts-btn": FTSBtn,
    "fts-modal": FTSModal,
    "fts-emoji": FTSEmoji,
    "fts-toggle-switch": FTSToggleSwitch,
    "fts-console-validator": FTSConsoleValidator,
    "fts-user-profile": FTSUserProfile,
    "fts-profile": FTSProfile,
    "fts-tippy": FTSTippy,
    "fts-invitation": FTSInvitation,
    "fts-workflow": FTSWorkflow,
    "fts-module-create-modal": FTSModuleCreateModal,
    "fts-module-import-design-modal": FTSModuleImportDesignModal,
    "fts-module-onboard-modal": FTSModuleOnboardModal,
    "fts-module-delete-modal": FTSModuleDeleteModal,
    "fts-module-packages": FTSModulePackages,
    "fts-workspace-modal": FTSWorkspaceModal,
    "fts-workspace-create-modal": FTSWorkspaceCreateModal,
    "fts-tour-modal": FTSTourModal,
    vueHeadful
  },
  store,
  data() {
    return {
      drawer: true,
      drawerToggle: false,
      drawerToggleButton: true,
      sidenavFlag: false,
      scroll: false,
      saving: false,
      workspaceSearch: null,
      workspaceOptionList: [],
      preWorkspaces: [],
      moduleCreateMode: null,
      userProfileCKey: 0,
      tourCallbacks: {
        onFinish: this.tourOnFinish,
        onStop: this.tourOnFinish,
      },
      loaded: false,
    };
  },
  validations() {
    let canvas = {};
    let vector = {};
    // information
    if (this.canvas.information && this.canvas.information.length) {
      canvas.information = {
        $each: {
          ...validator.informationDesign(this.canvas.information),
          $trackBy: "id"
        }
      };
    }
    // activities
    if (this.canvas.activities && this.canvas.activities.length) {
      canvas.activities = {
        $each: {
          ...validator.activityDesign(this.canvas.activities),
          $trackBy: "id"
        }
      };
    }
    // states
    if (this.canvas.states && this.canvas.states.length) {
      canvas.states = {
        $each: {
          ...validator.stateDesign(this.canvas.states),
          $trackBy: "id"
        }
      };
    }
    // flows
    if (this.canvas.flows && this.canvas.flows.length) {
      canvas.flows = {
        $each: {
          ...validator.flowDesign(this.canvas.flows),
          $trackBy: "id"
        }
      };
    }
    // module
    vector = validator.moduleDesign(this.workspaceModules);

    return { canvas, vector };
  },
  computed: {
    sidenavLogo() {
      return authorizationStore.getters.appLogo;
    },
    tourSteps() {
      let steps = [...tours.studioTourSteps];
      if (this.vectorId) {
        steps = steps.concat([...tours.moduleRunSteps]);
        if (!this.$store.getters.canvasInformation.length)
          steps = steps.concat([...tours.moduleStartSteps]);
      }
      return steps;
    },
    beta() {
      return this.$store.state.beta;
    },
    workspace() {
      return this.$store.state.workspace || {};
    },
    workspaceId() {
      return this.$store.getters.workspaceId;
    },
    workspaceModules() {
      return this.$store.getters.workspaceModules;
    },
    profile() {
      return authorizationStore.getters.userProfile;
    },
    userRoles() {
      return authorizationStore.getters.userRoles;
    },
    vector() {
      const module = this.$store.state.vector || {};
      if (module.id && Boolean(this.moduleCreateMode)) {
        this.moduleCreateMode = null;
      }
      return module;
    },
    vectorId() {
      return this.vector.id;
    },
    originalVector() {
      return this.$store.state.originalVector;
    },
    canvas() {
      return this.$store.state.canvas || {};
    },
    information() {
      return this.$store.getters.canvasInformation;
    },
    filteredWorkspaces() {
      let searchKey = this.workspaceSearch ? this.workspaceSearch : "";
      return this.workspaces.filter(
        x => x.name.toLowerCase().indexOf(searchKey.toLowerCase()) != -1
      );
    },
    clientRoute() {
      if (this.vectorId) {
        let listId = null;
        try {
          const menu = this.$store.getters.canvasMenus.find(x => !x.default);
          if (menu && menu.id) {
            listId = menu.id;
          }
        } catch(err) {
          console.warn('Studio:ClientRoute', err);
        }

        return commons.clientListViewRoute({
          moduleId: this.vectorId,
          listId: listId
        });
      } else {
        return { name: 'dashboard' }
      }
    },
    isDashboard() {
      return (
        this.$route.query &&
        this.$route.query.wsId &&
        !Boolean(this.moduleCreateMode) &&
        !this.vectorId
      );
    },
    studioContentClass() {
      if (this.vectorId || this.moduleCreateMode === 'create')
        return "studio-content--create";
      else if (this.moduleCreateMode === 'template')
        return "studio-content--template";
    },
  },
  watch: {
    workspaceSearch: _.debounce(async function() {
      this.workspaceOptionList = await this.$store.dispatch("searchWorkspace", {
        search: this.workspaceSearch
      });
    }, 500)
  },
  methods: {
    async startTour() {
      const res = await this.$refs.ftsTourModal.show();
      if (res) {
        const enableDrawer = () => 
          new Promise(resolve => {
            setTimeout(() => {resolve()}, 500);
          });

        if (!this.drawer) {
          this.drawer = true;
          await enableDrawer();
        }
        this.drawerToggleButton = false;
        this.$tours['myTour'].start();
      } else {
        this.tourOnFinish();
      }
    },
    tourOnFinish() {
      this.drawerToggleButton = true;
      $cookies.set("studio_toured", true, "1y");
    },
    toggleDrawer() {
      if (this.$tours && this.$tours["myTour"] && this.$tours["myTour"].isRunning)
        return;

      this.drawer = !this.drawer;
      if (!this.drawer) this.sidenavFlag = this.drawerToggle = false;
    },
    mouseoverDrawer() {
      this.sidenavFlag
        ? (this.drawerToggle = true)
        : (this.drawerToggle = false);
    },
    mouseleaveDrawer() {
      this.drawerToggle = this.sidenavFlag = false;
    },
    mouseoverSidenav() {
      this.drawerToggle = this.sidenavFlag = true;
    },
    mouseleaveSidenav() {
      this.drawerToggle = false;
    },
    onScroll(e) {
      this.scroll = e.target.scrollTop > 0;
      window.eventBus.$emit("ftsConsoleOnScroll");
    },
    async runApp(payload) {
      const dialogConfirmation = () =>
        new Promise(resolve => {
          const toSave = moduleGuard.compactModule(this.vector);
          const canvasDiffs = changesets.diff(this.originalVector, toSave);
          if (canvasDiffs && canvasDiffs.length) {
            this.$modal.show("dialog", {
              title: "Unsaved changes",
              text: `Save changes on ${this.vector.name} and continue ?`,
              buttons: [
                {
                  title: "No. Stay",
                  handler: () => {
                    this.$modal.hide("dialog");
                    resolve(false);
                  }
                },
                {
                  title: "Discard and continue",
                  handler: () => {
                    this.$modal.hide("dialog");
                    resolve(true);
                  }
                },
                {
                  title: "Save and continue",
                  handler: async () => {
                    this.$modal.hide("dialog");
                    await this.save();
                    resolve(true);
                  }
                },
              ]
            });
          } else {
            resolve(true);
          }
        });

      if (this.vectorId) {
        const res = await dialogConfirmation();
        if (payload && payload.target === '_blank') {
          const routeData = this.$router.resolve(this.clientRoute);
          window.open(routeData.href, '_blank');
        } else {
          res && this.$router.push(this.clientRoute);
        }
      } else {
        this.$router.push(this.clientRoute);
      }
    },
    openInvitation() {
      this.$refs.ftsInvitation.open();
    },
    async openUserProfileModal() {
      await this.$refs.ftsUserProfile.show();
    },
    openWorkspaceModal() {
      this.$refs.ftsWorkspaceModal.show();
    },
    async openWorkspaceCreateModal() {
      const workspaceId = await this.$refs.ftsWorkspaceCreateModal.show();
      if (workspaceId) {
        this.selectWorkspace({
          id: workspaceId
        });
      }
    },
    async selectList(menuId) {
      const menu =
        this.canvas &&
        Array.isArray(this.canvas.menus) &&
        this.canvas.menus.find(x => x.id === menuId);
      if (menu)
        this.$refs.console.openConsoleElement(
          { name: "menu", fieldName: "menus" },
          menu
        );
    },
    async selectModule(module) {
      if (this.vectorId == module.id) {
        return;
      }
      // !! issue, store cant find state => state.currentWorkspace
      // if (!module.currentWorkspace && module.ownerWorkspaceId != this.$store.state.currentWorkspace.id) {
      if (
        !module.currentWorkspace &&
        module.ownerWorkspaceId != this.workspaceId
      ) {
        if (
          !confirm(
            "This module is not own by current workspace, are you sure to change workspace?"
          )
        ) {
          return;
        }
      }

      let id = module.id;
      let toSave = moduleGuard.compactModule(this.vector);
      let canvasDiffs = changesets.diff(this.originalVector, toSave);
      console.log(canvasDiffs);

      if (this.vectorId && canvasDiffs && canvasDiffs.length) {
        let buttons = [
          {
            title: "OK. Discard Changes",
            default: true,
            handler: async () => {
              this.$modal.hide("dialog");
              await this.$store.dispatch("loadVector", id);

              if (
                this.$route.query &&
                commons.encodeids(this.$route.query.id) !==
                  commons.encodeids(this.vectorId)
              )
                this.$router.push({
                  query: { id: commons.encodeids(this.vectorId) }
                });
            }
          },
          {
            title: "No. Stay"
          }
        ];

        this.$modal.show("dialog", {
          title: "Unsaved changes",
          text: `Are you sure discard changes on ${this.vector.name} ?`,
          buttons: buttons
        });
      } else {
        await this.$store.dispatch("loadVector", id);

        if (
          this.$route.query &&
          commons.encodeids(this.$route.query.id) !==
            commons.encodeids(this.vectorId)
        )
          this.$router.push({
            query: { id: commons.encodeids(this.vectorId) }
          });
      }
    },
    /* module:create */
    cancelModuleCreate() {
      this.moduleCreateMode = null;
      this.openModuleCreateModal();
    },
    async openModuleCreateModal() {
      const res = await this.$refs.ftsModuleCreateModal.show();
      if (res === 'create' || res === 'template') {
        this.moduleCreateMode = res;
        this.$store.dispatch('resetVector');
        this.$router.push({
          query: { wsId: commons.encodeids(this.workspaceId) }
        });
      } else if (res === 'spreadsheet') {
        setTimeout(() => {
          this.openModuleImportDesignModal();
        }, 300);
      }
    },
    async openModuleImportDesignModal() {
      const res = await this.$refs.ftsModuleImportDesignModal.show();
      if (res) {
        await this.$store.dispatch("loadVector", res);
        this.$store.dispatch("updateWorkspaceMenus");
        this.$router.push({
          query: { id: commons.encodeids(this.vectorId)}
        });
        this.moduleCreateMode = null;
        setTimeout(() => {
          this.openModuleOnboardModal();
        }, 300);
      } else if (res === false) {
        setTimeout(() => {
          this.cancelModuleCreate();
        }, 300);
      }
    },
    async openModuleOnboardModal() {
      const res = await this.$refs.ftsModuleOnboard.show();
      if (res === 'tour') {
        this.startTour();
      }
    },
    moduleCreated() {
      if (!$cookies.get("studio_toured")) {
        this.startTour();
      }
    },
    /* module:delete */
    async deleteModule(item) {
      const result = await this.$refs.ftsModuleDeleteModal.show({
        id: item.id,
        name: item.name,
        emoji: item.emoji
      });
      if (result != null && result !== true) {
        try {
          await this.$store.dispatch("deleteVector", item.id);
          this.$router.replace({ query: { wsId: this.workspaceId } });
          this.$toasted.success(`${item.name} has been deleted.`);
        } catch (err) {
          if (
            err &&
            err.response &&
            err.response.data &&
            err.response.data.message
          ) {
            this.$toasted.error(
              "Failed to Delete: " + err.response.data.message
            );
          } else {
            console.error(err);
            this.$toasted.error("Failed to Delete");
          }
        }
      }
    },
    // workspace
    async beforeShowWorkspaceOptions() {
      await new Promise((resolve, reject) => {
        if (this.$tours && this.$tours["myTour"] && this.$tours["myTour"].isRunning) {
          const message = 'Before opening workspace settings, please complete or skip the tour';
          this.$toasted.info(message);
          reject(message);
        } else {
          resolve();
        }
      });
    },
    async showWorkspaceOptions() {
      this.workspaceSearch = "";
      this.workspaceOptionList = await this.$store.dispatch("searchWorkspace", {
        search: this.workspaceSearch,
        workspaceId: this.workspaceId
      });

      this.$nextTick(() => {
        this.$refs.workspaceSearch.focus();
      });
    },
    async selectWorkspace(res) {
      if (res && res.id) {
        if (Boolean(this.moduleCreateMode)) {
          this.moduleCreateMode = null;
        }

        try {
          await this.$store.dispatch("selectWorkspace", { id: res.id });
          this.$store.dispatch("resetVector");
          this.$router.push({
            query: { wsId: commons.encodeids(this.workspaceId) }
          });

          if (!this.workspaceModules.length) {
            this.openModuleCreateModal();
          }
        } catch (err) {
          if (err.response && err.response.data && err.response.data.message) {
            this.$toasted.error(err.response.data.message);
          } else {
            this.$toasted.error("unable load workspace");
          }
        }
      }
    },
    workflow() {
      this.$openStudioWorkflow();
    },
    async save() {
      this.$v.canvas.$touch();
      if (this.vectorId) {
        this.$v.vector.$touch();
      }

      if (this.$v.canvas.$invalid) {
        window.eventBus.$emit("consoleValidator", {
          validations: this.$v.canvas
        });
      } else if (this.$v.vector.$invalid && this.vectorId) {
        this.$toasted.error(
          "Studio: " + validator.moduleDesignError(this.$v.vector, "name")
        );
      } else {
        this.saving = true;
        let toastedMsg = `Workspace: ${this.workspace.name}`;

        try {
          await this.$store.dispatch("saveWorkspace");
          if (this.vectorId) {
            toastedMsg = `Module: ${this.vector.name}`;
            await this.$store.dispatch("saveVector");
          }
          /* to refresh the workspace after submitted */
          await this.$store.dispatch("selectWorkspace", {
            id: commons.decodeids(this.workspaceId)
          });
          this.$toasted.success(`${toastedMsg} successfully save.`);
        } catch (err) {
          this.$toasted.global.error({
            response: err.response,
            message: `${toastedMsg} error encountered.`
          });
        } finally {
          this.saving = false;
        }
      }
    },
    redirectDashboard() {
      if (!this.isDashboard) {
        this.moduleCreateMode = null;
        this.$store.dispatch("resetVector");
      }

      this.$router.push({
        query: { wsId: commons.encodeids(this.workspaceId) }
      });
    },
    studioContentScrollTo(coordinate) {
      const x = (coordinate && coordinate.x) || 0;
      const y = (coordinate && coordinate.y) || 0;
      this.$refs.studioContent.scrollTo(x, y);
    }
  },
  async mounted() {
    await webAppConfig.getConfig();
    /* temp:remove dark mode (until studio dark mode ready) */
    if (document.body.classList.contains('dark'))
      document.body.classList.remove('dark');
    /* profile */
    await authorizationStore.dispatch("profile");
    /* load studio */
    const query = this.$route.query;
    if (query.id) {
      try {
        await this.$store.dispatch("loadVector", commons.decodeids(query.id));
      } catch (err) {
        if (err.response && err.response.data && err.response.data.message) {
          this.$toasted.error(err.response.data.message);
        } else {
          this.$toasted.error("unable load module");
        }
        /* redirect to default workspace */
        setTimeout(() => {
          this.$router.push({
            query: { wsId: "" }
          });

          this.$router.go();
        }, 1500);
      }
    } else {
      let vm = this;
      let workspaceError = false;
      const workspaceId = query.wsId ? commons.decodeids(query.wsId) : null;
      async function loadWorkspace(id) {
        try {
          let res = await vm.$store.dispatch("loadWorkspace", {
            id: id
          });
          vm.$router.push({
            query: { wsId: commons.encodeids(res.id) }
          });
        } catch (err) {
          if (err.response && err.response.data && err.response.data.message) {
            vm.$toasted.error(err.response.data.message);
          } else {
            vm.$toasted.error("unable load workspace");
          }
          workspaceError = true;
        }
      }
      await loadWorkspace(workspaceId);
      /* attempts load workspace once */
      if (workspaceError) {
        await loadWorkspace();
      }
    }
    /* loaded */
    this.loaded = true;
    /* workspace settings */
    if (this.workspaceId) {
      /* pre-workspaces */ 
      try {
        const preWorkspaces = await this.$store.dispatch("searchWorkspace", {
          search: ""
        });
        this.preWorkspaces = [
          ...[{ id: this.workspaceId, name: this.workspace.name }],
          ...preWorkspaces.filter(x => x.id != this.workspaceId).slice(0, 2)
        ].map(x => ({
          id: x.id,
          name: x.name,
          shortName: x.name && x.name.substring(0, 2).toLowerCase()
        }));
      } catch (err) {
        console.error(err);
      }
      /* open create module modal */
      if (!this.workspaceModules.length) {
        this.openModuleCreateModal();
      }
      /* signalr */
      signalr.setupCommunication(this.workspaceId);
      /* module changed */
      // window.eventBus.$on("workspaceChanged", (data) => {
      //   console.log("changed workspace", data);
      // });
    }
    /* flow diagram */
    Vue.prototype.$openStudioWorkflow = () => {
      this.$refs.ftsWorkflow.show();
    };
  },
};
</script>

<style lang="scss">
@import "../src/assets/scss/vars.scss";

.module-designer-modal {
  .helper-label {
    color: var(--fts-gray-5);
    font-size: 0.875rem;
  }
  .emoji-select {
    display: flex;
    justify-content: center;
    margin: 1.25rem 0 1rem;
  }
  .fts-form-control {
    border-radius: 0.25rem;
  }
}
/* content header */
.content-header {
  @include backdrop-background($color: #fff, $alpha: 0.72, $blur: 20px);
  position: sticky;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  z-index: 50;
  .content-nav {
    display: flex;
    align-items: center;
    top: 0;
    left: 0;
    height: 55px;
  }
  .content-nav-l {
    width: calc(280px + 15%);
    padding: 0 1rem;
    .module-wrapper {
      min-width: 0;
      display: flex;
      align-items: center;
      .module-emoji {
        margin-right: 0.575rem;
      }
      .module-name {
        @include text-overflow-ellipsis;
        font-size: 1.25rem;
        font-weight: 500;
      }
      .module-tag {
        margin-left: 0.575rem;
        padding: 0.1rem 0.175rem;
        font-size: 0.675rem;
        border-radius: 0.25rem;
        background: var(--drawer-secondary-background);
        color: var(--drawer-secondary);
      }
    }
  }
  .content-nav-c {
    flex: 1 30%;
    .content-nav-wrapper {
      @include flex-center-middle;
      .content-nav-icon {
        margin-right: 0.575rem;
        font-size: 1.1rem;
        color: var(--fts-gray-5);
      }
      .content-nav-title {
        @include text-overflow-hidden;
        font-size: 1.5rem;
        font-weight: 500;
      }
      .content-nav-title + .content-nav-action {
        margin-left: 0.375rem;
      }
    }
  }
  .content-nav-r {
    width: calc(280px + 15%);
    padding: 0 1rem;
    .content-nav-actions {
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
}
/* studio content */
.studio-content {
  &.studio-content--scrolled {
    .content-header {
      box-shadow: 0 0 4px 0 #eee;
    }
  }
  &.studio-content--create {
    .content-header,
    .fts-console {
      min-width: 1024px;
    }
  }
  &.studio-content--template {
    .content-header,
    .fts-module-packages {
      min-width: 640px;
    }
  }
}
</style>